<template lang="pug">
  nav.w-100.center.pointer-events-none
    button.inline-block.p3.sm-p2.pointer-events-auto(@click="$emit('click')") INFORMATION
      //- <span v-if="open">•</span>
      //- <span v-else>•&nbsp;•&nbsp;•</span>
</template>

<script>
export default {
  name: 'InfoToggleBtn',
  props: ['open']
}
</script>



// WEBPACK FOOTER //
// src/components/InfoToggleBtn.vue